import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Button } from '../Button/Button.js';

const IconButton = /*#__PURE__*/ React__default.forwardRef(({ icon, isLoading = false, meaning = "neutral", prominence = "medium", scale = "small", ...restProps }, ref)=>{
    return jsx(Button, {
        ...restProps,
        ref: ref,
        isLoading: isLoading,
        leadingIcon: !isLoading ? icon : undefined,
        meaning: meaning,
        prominence: prominence,
        scale: scale,
        children: restProps.children
    });
});

export { IconButton };
